import { render, staticRenderFns } from "./MassPendingPlayers.vue?vue&type=template&id=3f39770b&scoped=true&"
import script from "./MassPendingPlayers.vue?vue&type=script&lang=js&"
export * from "./MassPendingPlayers.vue?vue&type=script&lang=js&"
import style0 from "./MassPendingPlayers.vue?vue&type=style&index=0&id=3f39770b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39770b",
  null
  
)

export default component.exports